
  import Vue from 'vue'

  export default Vue.extend({
    name: 'Login',

    data: () => ({
      info: false,
      email: '',
      password: '',
      showPassword: true,
    }),
    methods: {
      login() {
        this.$store.dispatch('auth/login', { email: this.email, password: this.password })
      }
    },
    computed: {
      loading() {
        return this.$store.getters['auth/getLoading']
      },
      getMsg() {
        return this.$store.getters['auth/getMsg']
      },
    },
    watch: {
      getMsg (value) {
        if (value)
          this.info = true
        else
          this.info = false
      },
    }
  })
